// extracted by mini-css-extract-plugin
export default {"sessionInfo":"sessionInfo-hBfnG","duration":"duration-leNbs"};